import React from "react"
import { Box, Button, SearchIcon } from "@carrotfertility/carotene-core"
import { FormTextField, useFormContext } from "@carrotfertility/carotene-core-x"
import { NO_URL_NEEDED } from "./utils/urlUtils"

type CarrotPlanLinkInputProps = {
  name: string
  stepUrl?: string | null
}

export function CarrotPlanLinkInput({ name, stepUrl }: CarrotPlanLinkInputProps): JSX.Element {
  const { setValue, trigger } = useFormContext()
  return (
    <Box display="flex" alignItems="center" flexDirection="row" gap={(theme) => theme.spacing(theme.tokens.spacing.xs)}>
      <FormTextField
        InputProps={stepUrl === NO_URL_NEEDED ? { readOnly: true, value: "No URL needed" } : {}}
        size="small"
        registerOptions={{
          validate: (value) => {
            if (stepUrl === NO_URL_NEEDED) {
              return true
            } else if (!value) {
              return "Required"
            }
          }
        }}
        onChange={(e) => {
          setValue(name, e.target.value)
          trigger(name)
        }}
        placeholder={"Paste url here"}
        name={name}
        data-testid={name}
        data-no-dnd="true"
      />
      <Button
        component="a"
        target="_blank"
        href={stepUrl}
        startIcon={<SearchIcon />}
        disabled={!stepUrl || stepUrl === NO_URL_NEEDED}
      >
        View
      </Button>
    </Box>
  )
}
